<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="-10 0 532 512"
    class="icon login"
  >
    <path
      d="M 99.5098,255.30134 V 468.95765 H 412.49025 V 255.30134 c -111.17463,0 -207.11518,0 -312.98045,0 z"
    />
    <path
      d="m 365.76253,183.1827 v -31.44725 c 0,-14.18209 -2.74543,-27.43926 -8.23632,-39.77152 -5.49089,-12.332247 -12.81203,-23.122973 -21.96351,-32.372163 -9.15147,-9.24919 -19.8282,-16.648543 -32.03017,-22.198057 -12.20197,-5.549515 -25.31908,-8.324272 -39.35135,-8.324272 -14.03226,0 -27.14938,2.774757 -39.35134,8.324272 -12.20197,5.549514 -22.8787,12.948867 -32.03017,22.198057 -9.15148,9.24919 -16.47266,20.039916 -21.96355,32.372163 -5.49088,12.33226 -8.23632,25.58943 -8.23632,39.77152 v 94.34174"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.menu__item.router-link-active .icon {
  &.login {
    animation: strokeLogin 0.9s reverse;
  }

  @keyframes strokeLogin {
    100% {
      stroke-dashoffset: 1280;
    }
  }
}

.icon.login {
  width: 2.3em;
  height: 2.3em;
  stroke-width: 20pt;
  stroke-dasharray: 1280;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgLogin.vue